<template>
  <div class="GlobalFormDemo">
    <GlobalForm class="global-form" :init-data="initData" :form-rules="formRules" :form-item-list="formItemList" :needBtnLoading="true"
      :inline="true" :labelWidth="80" round @handleConfirm="handleConfirm" confirmBtnName="查询">
      <el-form-item class="el_from" label="角色" slot="operationSelect" style="margin:0">
        <el-select v-model="roleId" placeholder="请选择" clearable @change="roleSeacChange">
          <el-option v-for="item in byRoleList" :key="item.id" :label="item.roleName" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="el_from" label="所属门店" slot="storeIdSelect" style="margin:0">
        <el-select v-model="storeId" placeholder="请选择所属门店" clearable @change="storeSeachChange" filterable>
          <el-option v-for="item in storeList" :key="item.key" :label="item.value" :value="item.key"></el-option>
        </el-select>
      </el-form-item>
      <div class="active-not-select" slot="activeNotSelect">
        <span>最近</span>
        <el-select v-model="activeNot" placeholder="请选择" clearable>
          <el-option label="3天" value="01"></el-option>
          <el-option label="7天" value="02"></el-option>
          <el-option label="15天" value="03"></el-option>
          <el-option label="30天" value="04"></el-option>
        </el-select>
        <span>没有登录或下单</span>
      </div>
      <div style="text-align: right; margin-bottom: 20px" v-if="type == '01'" slot="AddSlot">
        <el-button size="small" type="primary" icon="el-icon-plus" @click="staffAdd('add')">添加职员</el-button>
      </div>
    </GlobalForm>

    <div style="text-align: right; margin-bottom: 20px" v-if="type == '02'">
      <div style="
          text-align: left;
          margin-bottom: 20px;
          display: inline-block;
          float: left;
        ">
        <div style="display: flex" v-if="false">
          <span style="font-weight: 700">店长是否可查看回收数据</span>
          <el-tooltip class="item" effect="dark" content="回收数据指小程序统计页面的回收数量、询价数量、报价数量。" placement="bottom">
            <i style="
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                margin-left: 4px;
                vertical-align: -10%;
                margin-right: 10px;
              " class="el-icon-warning-outline"></i></el-tooltip>
          <el-switch inactive-color="#bebebe" @change="canSeeDatachange($event)" v-model="canSeeData"></el-switch>
        </div>
      </div>
      <el-button size="small" type="primary" icon="el-icon-plus" @click="staffAdd('add')">添加职员</el-button>
      <el-button size="small" type="warning" icon="el-icon-upload" @click="staffAdd('import')">批量导入</el-button>
      <el-button size="small" type="success" icon="el-icon-download" :loading="exportLoading" @click="exportTable">导出数据</el-button>
    </div>
    <el-dialog class="add-dialog" :title="dialogTitle" :visible.sync="dialogVisible" :close-on-click-modal="false"
      width="600px" @closed="handleDialogClosed">
      <el-form ref="addForm" :model="staffForm" :rules="dialogRules" label-width="100px" v-if="dialogTitle == '添加职员'">
        <el-form-item label="职员姓名" prop="staffName">
          <el-input placeholder="输入职员姓名（10字内）" v-model.trim="staffForm.staffName" @input="change($event)" clearable>
          </el-input>
        </el-form-item>
        <div v-if="type == '01'">
          <el-form-item label="联系电话" prop="staffMobile">
            <el-input placeholder="输入职员电话号码（11位）" v-model.number="staffForm.staffMobile"
              onkeyup="value=value.replace(/[^\w\.\/]/ig,'')" @input="change($event)" clearable>
            </el-input>
          </el-form-item>
          <el-form-item label="职员角色" prop="roleId">
            <el-select v-model="staffForm.roleId" clearable placeholder="请选择角色" @change="roleChange">
              <el-option v-for="ele in byRoleList" :key="ele.id" :label="ele.roleName" :value="ele.id"></el-option>
            </el-select>
          </el-form-item>
        </div>

        <div v-if="(roleNo == '02' || roleNo == '01') && type == '01'">
          <el-form-item :label="roleNo == '02' ? '选择总监' : '选择子账号'" prop="xcxStaffId">
            <el-select v-model="staffForm.xcxStaffId" clearable placeholder="请选择" :no-data-text="roleNo == '02'
              ? '请先添加总监的小程序账号'
              : '请先添加子账号的小程序账号'
              ">
              <el-option v-for="ele in xcxStaffList" :key="ele.staffId" :label="ele.staffName"
                :value="ele.staffId"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div v-if="type == '01'">
          <el-form-item label="登录账号" prop="userAcc" class="acc">
            <el-input v-model="staffForm.userAcc" placeholder="输入登录账号（6-16位字母数字）" @input="change($event)"
              @blur="staffForm.userAcc = $event.target.value" onkeyup="value=value.replace(/[^\w\.\/]/ig,'')"></el-input>
            <div style="float: right">
              <el-button type="primary" size="medium" @click="createPcAcc">自动生成</el-button>
            </div>
          </el-form-item>
          <el-form-item label="登录密码" prop="userPwd">
            <el-input onfocus="this.type='password'" @input="change($event)" v-model.trim="staffForm.userPwd"
              placeholder="输入登录密码（6-16位字符，含字母、数字或符号）"></el-input>
          </el-form-item>
        </div>

        <div v-if="type == '02'">
          <!-- 小程序添加 -->
          <el-form-item label="员工编码" prop="staffCode">
            <el-input placeholder="请输入员工编码，如员工erp编码" v-model.trim="staffForm.staffCode" maxlength="30"
              @input="change($event)" clearable>
            </el-input>
          </el-form-item>

          <el-form-item label="职员职位" prop="staffType">
            <el-select v-model="staffForm.staffType" clearable placeholder="请选择职位" @change="selsectType">
              <el-option v-for="ele in roleList" :key="ele.value" :label="ele.label" :value="ele.value"></el-option>
            </el-select>
          </el-form-item>
        </div>

        <el-form-item label="管辖区域" v-show="staffForm.staffType && staffForm.staffType == '02'">
          <el-select v-model="staffForm.areaId" clearable placeholder="请选择区域" filterable>
            <el-option v-for="ele in Regionaldata" :key="ele.id" :label="ele.name" :value="ele.id"></el-option>
          </el-select>
        </el-form-item>

        <div v-if="type == '02' && staffForm.staffType != '01'">
          <el-form-item label="管辖门店" prop="storeIds" v-show="staffForm.staffType && staffForm.staffType == '02'">
            <el-select v-model="staffForm.storeIds" clearable placeholder="请选择门店" multiple @remove-tag="removetag"
              filterable>
              <el-option v-if="storeList.length" label="全部选择" :value="all"
                @click.native="chagestoreIds(staffForm.storeIds)"></el-option>
              <el-option v-for="ele in storeList" :key="ele.key" :label="ele.value" :value="ele.key"
                @click.native="chagestoreIdall(staffForm.storeIds)"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属门店" prop="storeIds" v-show="staffForm.staffType &&
            staffForm.staffType != '01' &&
            staffForm.staffType != '02'
            ">
            <el-select v-model="staffForm.storeId" filterable clearable placeholder="请选择门店" no-data-text="请先选择职员职位"
              @clear="storeClear" @change="storeChange">
              <div v-if="storeList.length">
                <el-option v-for="ele in storeList" :key="ele.key" :label="ele.value" :value="ele.key"></el-option>
              </div>
              <el-option v-else style="color: #999; font-weight: normal">请先添加门店</el-option>
            </el-select>
          </el-form-item>
        </div>
        <div v-if="type == '02'">
          <el-form-item label="登录手机号" prop="staffMobile">
            <el-input placeholder="输入职员电话号码（11位）" v-model.number="staffForm.staffMobile"
              onkeyup="value=value.replace(/[^\w\.\/]/ig,'')" @input="change($event)" clearable>
            </el-input>
          </el-form-item>
        </div>
      </el-form>
      <div class="step" v-else>
        <div class="step-title">
          <img src="@/assets/images/ico_ts_red.png" alt="" style="width: 18px; height: 18px; margin-right: 5px" />
          <span>温馨提示:请按模板表格严格填写，带*的为必填项，店员头像需上传后手动在系统中添加。</span>
        </div>
        <div class="step-content">
          <el-button type="success" icon="el-icon-download" size="medium" @click="download">下载数据模板</el-button>
        </div>
        <el-form ref="importForm" :model="importForm" :rules="importRules" label-width="80px">
          <el-form-item label="表格上传" prop="fileName" class="fileName">
            <el-input v-model="importForm.fileName" @clear="fileClear" :disabled="true" size="medium" clearable>
            </el-input>
            <div style="float: right; position: relative">
              <el-button size="medium" type="warning" icon="el-icon-upload2">上传表格</el-button>
              <input accept=".xls, .xlsx" ref="fileUpload" @change="onUploadList" type="file" style="
                  opacity: 0;
                  width: 100%;
                  height: 100%;
                  position: absolute;
                  top: 0;
                  left: 0;
                  cursor: pointer;
                " />
            </div>
            <div style="color: #ff687b">
              仅支持.xls及.xlsx格式,单次上传大小不超过5M
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="handleClose">取消</el-button>
        <el-button type="primary" @click.native="handleSuccess">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog class="export-dialog" title="导出店员数据" :visible.sync="exportDialogVisible" :close-on-click-modal="false"
      width="400px" @closed="exportDialogClosed">
      <div style="margin: 20px 0">
        <span>选择门店：</span>
        <el-select v-model="exportStoreId" filterable clearable placeholder="请选择门店">
          <el-option v-for="item in storeList" :key="item.key" :label="item.value" :value="item.key">
          </el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="exportDialogClosed">取消</el-button>
        <el-button type="primary" @click.native="exportSuccess">确定导出</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  formValidateMobile,
  formValidateNumberAlphabets,
  formValidateNumberAlphabets2,
} from "@/utils/form-validate";
import _api from "@/utils/request";
export default {
  name: "Form",
  props: {
    byRoleList: {
      type: Array,
    },
  },
  data() {
    return {
      Regionaldata: [],
      canSeeData: "",
      all: undefined,
      roleId: "",
      storeId: "",
      activeNot: "",
      xcxStaffList: [],
      initData: null,
      dialogTitle: "",
      dialogVisible: false,
      exportDialogVisible: false,
      storeList: [],
      roleNo: "",
      exportStoreId: "",
      staffForm: {
        staffCode: "",
        staffName: "",
        staffType2: "",
        userAcc: "",
      },
      paramsExcel: {},
      importForm: {
        fileName: "",
      },
      roleList: [
        {
          value: "01",
          label: "子账号",
        },
        {
          value: "02",
          label: "总监",
        },
        {
          value: "03",
          label: "店长",
        },
        {
          value: "04",
          label: "店员",
        },
      ],
      formItemList: [
        {
          key: "staffName",
          type: "input",
          labelName: "职员名称",
          placeholder: "请输入职员名称",
        },
        {
          key: "staffMobile",
          type: "input",
          labelName: "联系电话",
          placeholder: "请输入联系电话",
        },
        { slotName: "operationSelect" },
        { slot: "AddSlot" },
      ],
      formRules: {},
      dialogRules: {
        staffName: [
          {
            required: true,
            message: "输入职员姓名（10字内）",
            trigger: "blur",
          },
          {
            min: 1,
            max: 10,
            message: "输入职员姓名（10字内）",
            trigger: "blur",
          },
        ],
        staffMobile: [
          {
            required: true,
            message: "请输入职员电话号码（11位）",
            trigger: "blur",
          },
          { validator: formValidateMobile, trigger: "blur" },
        ],
        roleId: [{ required: true, message: "请选择角色", trigger: "change" }],
        xcxStaffId: [{ required: true, message: "请选择", trigger: "change" }],
        userAcc: [
          {
            required: true,
            message: "输入登录账号（6-16位字母数字）",
            trigger: "blur",
          },
          {
            required: true,
            validator: formValidateNumberAlphabets,
            trigger: "blur",
          },
        ],
        userPwd: [
          {
            required: true,
            message: "输入登录密码（6-16位字符，含字母、数字或符号）",
            trigger: "blur",
          },
          {
            min: 6,
            max: 16,
            message: "6-16位字符，含字母、数字或符号",
            trigger: "blur",
          },
        ],
        staffType: [
          { required: true, message: "请选择职位", trigger: "change" },
        ],
        storeIds: [{ required: true, message: "请选择", trigger: "change" }],
      },
      importRules: {
        fileName: [{ required: true, message: "请上传表格", trigger: "blur" }],
      },
      type: "01",
      exportLoading: false
    };
  },
  created() {
    if(this.$route.query && this.$route.query.type == 'xcx'){
      this.type = '02'
      this.storeId = this.$route.query.storeId
      this.initData = {
        staffMobile2: this.$route.query.mobile
      }
      this.formItemList = [
        { slotName: "storeIdSelect" },
        {
          key: "staffType",
          type: "select",
          labelName: "职位",
          placeholder: "请选择职位",
          lableWidth: "50px",
          option: [
            {
              value: "01",
              label: "子账号",
            },
            {
              value: "02",
              label: "总监",
            },
            {
              value: "03",
              label: "店长",
            },
            {
              value: "04",
              label: "店员",
            },
          ],
        },
        {
          key: "staffName2",
          type: "input",
          labelName: "职员名称",
          placeholder: "请输入职员名称",
        },
        {
          key: "staffMobile2",
          type: "input",
          labelName: "联系电话",
          placeholder: "请输入联系电话",
        },
        {
          key: "staffType2",
          type: "select",
          labelName: "是否关注公众号",
          placeholder: "全部",
          lableWidth: "110px",

          option: [
            {
              value: "01",
              label: "是",
            },
            {
              value: "02",
              label: "否",
            },
          ],
        },
        {
          key: "doneOrder",
          type: "select",
          labelName: "是否下过单",
          placeholder: "全部",
          lableWidth: "110px",

          option: [
            {
              value: "00",
              label: "全部",
            },
            {
              value: "01",
              label: "是",
            },
            {
              value: "02",
              label: "否",
            },
          ],
        },
        { slotName: "activeNotSelect", lableWidth: "0px" },
        // { slot: "AddSlot" },
      ];
    }else {
      this.formItemList = [
        {
          key: "staffName",
          type: "input",
          labelName: "职员名称",
          placeholder: "请输入职员名称",
        },
        {
          key: "staffMobile",
          type: "input",
          labelName: "联系电话",
          placeholder: "请输入联系电话",
        },
        { slotName: "operationSelect" },
        { slot: "AddSlot" },
      ];
    }
    this.getStoreSelectList();
    // this.roleSelectByRole()

    _api.getWorkerList({ type: "02" }).then((res) => {
      console.log(
        res.data.shopownerCanSeeRecycleData,
        ">>>>>>>>>>>>>>>>>>>>>>>>>>>>>"
      );
      this.canSeeData = res.data.shopownerCanSeeRecycleData;
    });
    this.handleConfirm(this.initData)
  },
  computed: {
    SeachParams() {
      return this.$store.state.tagsView.SeachParams;
    },
  },
  watch: {
    "staffForm.xcxStaffId"(v){
      console.log(v);
      const data  = this.xcxStaffList.find(item=>item.staffId === v);
      console.log(data);
      // 选择子账号填充名称和手机号
      if(this.type === '01'){
        this.staffForm = {
          ...this.staffForm,
          staffName:data.staffName,
          staffMobile:data.staffMobile
        }
      }
    },
    SeachParams(newVal) {
      console.log(newVal);
      if (newVal.type == "01") {
        this.type = "01";
        this.activeNot = "";
        this.formItemList = [
          {
            key: "staffName",
            type: "input",
            labelName: "职员名称",
            placeholder: "请输入职员名称",
          },
          {
            key: "staffMobile",
            type: "input",
            labelName: "联系电话",
            placeholder: "请输入联系电话",
          },
          { slotName: "operationSelect" },
          { slot: "AddSlot" },
        ];
      } else {
        this.type = "02";
        this.activeNot = newVal.activeNot || "";
        this.formItemList = [
          { slotName: "storeIdSelect" },
          {
            key: "staffType",
            type: "select",
            labelName: "职位",
            placeholder: "请选择职位",
            lableWidth: "50px",
            option: [
              {
                value: "01",
                label: "子账号",
              },
              {
                value: "02",
                label: "总监",
              },
              {
                value: "03",
                label: "店长",
              },
              {
                value: "04",
                label: "店员",
              },
            ],
          },
          {
            key: "staffName2",
            type: "input",
            labelName: "职员名称",
            placeholder: "请输入职员名称",
          },
          {
            key: "staffMobile2",
            type: "input",
            labelName: "联系电话",
            placeholder: "请输入联系电话",
          },
          {
            key: "staffType2",
            type: "select",
            labelName: "是否关注公众号",
            placeholder: "全部",
            lableWidth: "110px",

            option: [
              {
                value: "01",
                label: "是",
              },
              {
                value: "02",
                label: "否",
              },
            ],
          },
          {
            key: "doneOrder",
            type: "select",
            labelName: "是否下过单",
            placeholder: "全部",
            lableWidth: "110px",

            option: [
              {
                value: "00",
                label: "全部",
              },
              {
                value: "01",
                label: "是",
              },
              {
                value: "02",
                label: "否",
              },
            ],
          },
          { slotName: "activeNotSelect", lableWidth: "0px" },
          // { slot: "AddSlot" },
        ];
      }
    },
  },
  methods: {
    // 店长是否可以查看回收数据
    canSeeDatachange(e) {
      console.log(e, "原状态");
      _api
        .updateCanSeeRecycleData({ shopownerCanSeeRecycleData: e })
        .then((res) => {
          console.log("是否可查看回收数据", res);
          this.$message({
            message: "操作成功！",
            type: "success",
          });
        });
    },

    chagestoreIds(e) {
      console.log(e, "门店id值改变");
      if (e.indexOf(undefined) == -1) {
        this.staffForm.storeIds = [];
      } else if (e.indexOf(undefined) != -1) {
        this.storeList.forEach((item) => {
          this.staffForm.storeIds.push(item.key);
        });
        this.staffForm.storeIds = [...new Set(this.staffForm.storeIds)];
      }
    },
    chagestoreIdall(e) {
      console.log(e, "非全选选择");
      if (e.length == this.storeList.length && e.indexOf(undefined) != -1) {
        e.forEach((item, i) => {
          if (item == undefined) {
            this.staffForm.storeIds.splice(i, 1);
          }
        });
      } else if (
        e.length == this.storeList.length &&
        e.indexOf(undefined) == -1
      ) {
        this.staffForm.storeIds.push(undefined);
      }
    },
    removetag() {
      this.chagestoreIdall(this.staffForm.storeIds);
    },

    roleSeacChange(val) {
      this.roleId = val;
    },
    storeSeachChange(val) {
      this.storeId = val;
    },
    //查询
    handleConfirm(data,cd) {
      let SeachParams = {};
      this.pageNum = 1;
      console.log(this.SeachParams);
      if (this.SeachParams.type == "01") {
        SeachParams = {
          roleId: this.roleId,
          staffMobile: data.staffMobile,
          staffName: data.staffName,
          type: this.SeachParams.type,
          pageNum: this.pageNum,
          pageSize: 10,
        };
      } else {
        SeachParams = {
          staffType: data.staffType,
          staffMobile: data.staffMobile2,
          staffName: data.staffName2,
          storeId: this.storeId,
          type: this.SeachParams.type || this.type,
          pageNum: 1,
          pageSize: 10,
          isSubscribe: data.staffType2,
          doneOrder: data.doneOrder,
          activeNot: this.activeNot,
        };
        console.log(SeachParams, "-------------------------------------");
      }
      SeachParams.disuseLoding = () => {
        if (typeof cd === 'function') {
          cd()
        }
      },
      this.$store.commit("tagsView/SEACH_PARAMS", SeachParams);
    },
    staffAdd(val) {
      this.areagetAreaSelect()
      console.log(val);
      if (val == "add") {
        this.dialogTitle = "添加职员";
        this.dialogVisible = true;
      } else {
        this.dialogTitle = "批量导入";
        this.dialogVisible = true;
      }
    },
    getStoreSelectList(params) {
      _api.getStoreSelectList(params).then((res) => {
        this.storeList = res.data;
        console.log(this.storeList, ":::::::::::::::::::::::::::::::");
      });
    },
    // 自动生成账号
    createPcAcc() {
      if (!this.staffForm.staffName) {
        this.$message.error("请先输入职员姓名");
        return;
      }
      _api.createPcAcc({ name: this.staffForm.staffName }).then((res) => {
        console.log(res);
        this.staffForm.userAcc = res.msg;
      });
    },
    // 选择角色
    roleChange(e) {
      console.log(e);
      if (this.staffForm.xcxStaffId) {
        this.staffForm.xcxStaffId = "";
      }
      if (!e) {
        return;
      }
      console.log(this.byRoleList);
      let obj = this.byRoleList.find((item) => {
        //这里的Data就是上面遍历的数据源
        return item.id === e; //筛选出匹配数据
      });
      this.roleNo = obj.roleNo;
      _api.getXcxStaffSelectByRole({ roleId: obj.id }).then((res) => {
        this.xcxStaffList = res.data;
      });
    },
    // 选择职位
    selsectType(e) {
      if (this.staffForm.storeIds && this.staffForm.storeIds.length > 0) {
        this.staffForm.storeIds = [];
      }
      if (this.staffForm.storeId) {
        this.staffForm.storeId = "";
      }
      if (!e) {
        return;
      }
      this.getStoreSelectList({ staffType: e });
    },
    storeChange(e) {
      console.log(e);
      if (!e) {
        return;
      }
      this.staffForm.storeIds = [];
      this.staffForm.storeIds.push(e);
    },
    storeClear() {
      this.staffForm.storeIds = [];
      this.staffForm.storeId = "";
    },
    // 保存后台账号
    handleSuccess() {
      if (this.staffForm.storeIds) {
        this.staffForm.storeIds.forEach((item, i) => {
          if (item == null) {
            this.staffForm.storeIds.splice(i, 1);
          }
        });
      }
      let formName = "";
      if (this.$refs["addForm"]) {
        formName = "addForm";
      } else {
        formName = "importForm";
      }
      this.$refs[formName].validate((valid) => {
        console.log(valid);
        if (valid) {
          if (this.type == "01") {
            _api.savePcStaff(this.staffForm).then((res) => {
              this.$message.success("添加成功");
              this.dialogVisible = false;
            });
          } else if (this.type == "02") {
            if (this.dialogTitle == "添加职员") {
              _api.saveXcxStaff(this.staffForm).then((res) => {
                this.$message.success("添加成功");

                this.dialogVisible = false;
              });
            } else {
              this.uploadFile();
            }
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 弹窗关闭
    handleDialogClosed() {
      console.log("弹窗关闭");
      if (this.$refs["addForm"]) {
        this.$refs["addForm"].resetFields();
      } else {
        this.$refs.fileUpload.value = "";
        this.$refs["importForm"].resetFields();
      }
      this.importForm = {
        fileName: "",
      };
      this.staffForm = {
        staffName: "",
        staffMobile: "",
        roleId: "",
        xcxStaffId: "",
        userAcc: "",
        userPwd: "",
        staffType: "",
        storeIds: [],
        areaId: "",
      };
      this.roleNo = "";
      this.paramsExcel = {};
      this.dialogVisible = false;
      console.log(this.SeachParams);
      this.handleConfirm(this.SeachParams);
    },
    handleClose() {
      this.dialogVisible = false;
    },
    uploadFile() {
      if (!this.paramsExcel.file || this.paramsExcel.file.length == 0) {
        return this.$message.error("请上传表格");
      }
      const fd = new FormData();
      fd.append("file", this.paramsExcel.file[0]); //文件
      console.log(fd);
      // 发起请求
      _api
        .importXcxStaff(fd)
        .then((res) => {
          console.log("_RequestUploads_", res);
          if (res.code === 1) {
            this.$message({
              type: "success",
              message: res.msg,
            });
            this.importForm.fileName = "";
            this.$refs.fileUpload.value = "";
            this.dialogVisible = false;
          }
        })
        .catch((err) => {
          this.importForm.fileName = "";
          this.$refs.fileUpload.value = "";
        });
    },
    onUploadList(event, type) {
      console.log(event);
      this.paramsExcel.file = event.target.files;
      if (this.paramsExcel.file.length) {
        this.paramsExcel.excelName = event.target.files[0].name;
        this.importForm.fileName = event.target.files[0].name;
      }
    },
    download() {
      const link = document.createElement("a");
      link.href = "/static/导入员工模版.xlsx";
      link.setAttribute("download", "导入员工模版.xlsx");
      document.body.appendChild(link);
      link.click();
    },
    fileClear() {
      this.$refs.fileUpload.value = "";
      this.paramsExcel = {};
    },
    change(e) {
      this.$forceUpdate();
    },
    exportDialogClosed() {
      this.exportDialogVisible = false;
      this.exportStoreId = "";
    },
    exportTable() {
      // this.exportDialogVisible = true;
      this.exportSuccess()
    },
    exportSuccess() {
      this.exportLoading = true
      _api.exportXcxStaff(this.SeachParams).then((res) => {
        const content = res;
        const blob = new Blob([content]);
        let reader = new FileReader(); // 创建读取文件对象
        reader.addEventListener("loadend", () => {
          try {
            let data = JSON.parse(reader.result);
            if (data.code === 0) {
              this.$message.error(data.msg || "服务异常");
            }
          } catch (err) {
            const fileName = "小程序职员列表.xlsx";
            if ("download" in document.createElement("a")) {
              // 非IE下载
              const elink = document.createElement("a");
              elink.download = fileName;
              elink.style.display = "none";
              elink.href = URL.createObjectURL(blob);
              document.body.appendChild(elink);
              elink.click();
              URL.revokeObjectURL(elink.href); // 释放URL 对象
              document.body.removeChild(elink);
            } else {
              // IE10+下载
              navigator.msSaveBlob(blob, fileName);
            }
          }
        });
        reader.readAsText(blob, "utf-8");
        this.exportDialogVisible = false;
      }).finally(() => {
            this.exportLoading = false;
          });
    },
    areagetAreaSelect() {
      _api.areagetAreaSelect({ scope: "01" }).then((res) => {
        this.Regionaldata = res.data;
      });
    }
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.GlobalFormDemo {
  .add-dialog {
    /deep/.el-select {
      width: 100%;
    }

    .acc {
      /deep/.el-input {
        width: 260px;
      }
    }
  }

  .step {
    .step-title {
      display: flex;
      color: #ff687b;
      margin-bottom: 18px;
    }

    .fileName {
      /deep/.el-input {
        width: 260px;
      }
    }

    .step-content {
      margin-bottom: 20px;
    }
  }

  /deep/.el-dialog__body {
    padding: 21px 50px 0;
  }

  /deep/.el-tag.el-tag--info {
    background-color: #fbfbfb;
    border-color: #cecdcd;
    color: #666666;
  }

  .global-form {
    /deep/.el-input__inner {
      width: 160px;
    }

    .active-not-select {
      display: inline-flex;
      align-items: center;
      color: #666;

      span {
        white-space: nowrap;
      }

      /deep/.el-select {
        margin: 0 8px;
      }

      /deep/.el-input__inner {
        width: 120px;
      }
    }
  }
}
</style>
